import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import SkillCluster from '../SkillCluster';
import ActivitySynthesisTable from '../ActivitySynthesisTable';
import { TYPE_MAPPING } from '../../constants/typeMapping';

const Details = ({ results }) => {
  if (!results) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>No results available</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mb: 3 }}>
            <ActivitySynthesisTable results={results} />
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <SkillCluster results={results} typeMapping={TYPE_MAPPING} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Details; 